import React, { useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { buildResume } from '../../resume-engine/buildResume';
import type { ResumeLayoutMode, ResumeVariantId } from '../../resume-engine/types';
import { PrintLayout } from './layouts/PrintLayout';
import { ExecutiveLayout } from './layouts/ExecutiveLayout';
import { ATSLayout } from './layouts/ATSLayout';
import './resume.scss';

function PrintResumePage() {
  const [searchParams] = useSearchParams();
  const variant = (searchParams.get('variant') as ResumeVariantId) || 'fullstack';
  const layout = (searchParams.get('layout') as ResumeLayoutMode) || 'print';
  const autoPrint = searchParams.get('autoprint') === '1';

  const resume = useMemo(() => buildResume(variant, layout), [variant, layout]);

  useEffect(() => {
    if (autoPrint) {
      const timer = setTimeout(() => window.print(), 500);
      return () => clearTimeout(timer);
    }
  }, [autoPrint, resume]);

  return (
    <div className="resume-print-page">
      {layout === 'ats' ? (
        <ATSLayout resume={resume} />
      ) : layout === 'executive' ? (
        <ExecutiveLayout resume={resume} />
      ) : (
        <PrintLayout resume={resume} />
      )}
    </div>
  );
}

export default PrintResumePage;
